/**
 * Student identity helpers
 *
 * 一律以 `serialNumber` 為主、`studentId` 為備援。Spinner 範圍內所有
 * React key 與「兩位學生是否同一人」的比對都應走這兩個 helper。
 */

import type { Student } from '@/services/bridge/types/bridge.types'

interface StudentIdentity {
  studentId: string | null
  serialNumber: number | null
}

/**
 * 雙方 studentId 皆非 null → 比 studentId；
 * 否則 雙方 serialNumber 皆非 null → 比 serialNumber；
 * 皆不可用 → false（視為比對失敗）。
 */
export const matchStudent = (
  a: StudentIdentity,
  b: StudentIdentity
): boolean => {
  if (a.studentId !== null && b.studentId !== null) {
    return a.studentId === b.studentId
  }
  if (a.serialNumber !== null && b.serialNumber !== null) {
    return a.serialNumber === b.serialNumber
  }
  return false
}

/**
 * `serialNumber` 非 null → `sn:<serialNumber>`，否則 `id:<studentId>`。
 * 前綴用於避免 `serialNumber=42` 與 `studentId="42"` 碰撞。
 *
 * Invariant：兩者不會同時為 null（normalizer 已強制），所以一定回傳一個 string。
 */
export const studentKey = (student: Student): string => {
  if (student.serialNumber !== null) {
    return `sn:${student.serialNumber}`
  }
  return `id:${student.studentId}`
}
